module.exports = __webpack_public_path__ + "static/media/logo-spin.511f76f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-spin.svg
// module id = 51
// module chunks = 2